import type { QueryClient, QueryKey } from '@tanstack/react-query';

export const rereadNow = async (queryClient: QueryClient, queryKey: QueryKey): Promise<void> => {
  await queryClient.cancelQueries({ queryKey });
  await queryClient.invalidateQueries({ queryKey });
};
